"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractModules = void 0;
var api_helper_const_1 = require("@const/api-helper.const");
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var input_mapping_const_1 = require("@const/input.mapping.const");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var translation_1 = __importDefault(require("@services/translation"));
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var time_mapping_const_1 = require("@src/modules/shared/validation/time-mapping.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = require("lodash");
var ContractModules = /** @class */ (function () {
    function ContractModules() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.numberOfModules = 0;
        this.initialRender = true;
        this.allModules = [];
    }
    ContractModules.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var studioData;
            var _this = this;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, (0, api_helper_const_1._GetOfferings)()];
                    case 1:
                        studioData = _f.sent();
                        if (!studioData) {
                            return [2 /*return*/];
                        }
                        this.findOfferingAndTerm(studioData.offerings);
                        if (!this.selectedOffering) {
                            console.warn('Addon selection found no offerings, cant display addons');
                        }
                        // remove modules that are not available for the selected offering
                        this.cleanUnavailableModules();
                        // redirect if no modules are selectable for this contract
                        if (!((_b = (_a = this.selectedOffering) === null || _a === void 0 ? void 0 : _a.selectableModules) === null || _b === void 0 ? void 0 : _b.length) && !((_d = (_c = this.selectedTerm) === null || _c === void 0 ? void 0 : _c.optionalModules) === null || _d === void 0 ? void 0 : _d.length)) {
                            this.redirectToContinue();
                        }
                        if ((_e = this.config.get) === null || _e === void 0 ? void 0 : _e.modules) {
                            this.config.get.modules.renderModule = function (preselect) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (preselect) {
                                                this.preselectModules();
                                            }
                                            return [4 /*yield*/, this.renderModule()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); };
                        }
                        this.preselectModules();
                        return [4 /*yield*/, this.renderModule()];
                    case 2:
                        _f.sent();
                        if (this.numberOfModules === 0) {
                            console.error('NO modules in contract (modules|selectableModules|optionalModules) why you show this page?', this.selectedOffering, this.selectedTerm);
                        }
                        this.prepareEventListeners();
                        this.communicationService.subscribeGlobally().subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var studioData_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(data.event === 'custom' && (data.name === 'membershipSelected' || data.name === 'studioSelected'))) return [3 /*break*/, 2];
                                        console.log('membership or studio changed, loading addons');
                                        return [4 /*yield*/, (0, api_helper_const_1._GetOfferings)()];
                                    case 1:
                                        studioData_1 = _a.sent();
                                        console.log('loaded addon offerings', studioData_1);
                                        if (!studioData_1) {
                                            return [2 /*return*/];
                                        }
                                        this.findOfferingAndTerm(studioData_1.offerings);
                                        console.log('addon term is now', this.selectedOffering);
                                        this.resetSelectedModules();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractModules.prototype.resetSelectedModules = function () {
        localStorage.setItem('selectableModules', '[]');
        localStorage.setItem('optionalModules', '[]');
        localStorage.setItem('optionalModules-names', '[]');
        localStorage.setItem('selectableModules-names', '[]');
        this.renderModule();
    };
    ContractModules.prototype.renderModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.allModules = [];
                        return [4 /*yield*/, this.fillModuleData('modules')];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, this.fillModuleData('selectableModules')];
                    case 2:
                        _c.sent();
                        return [4 /*yield*/, this.fillModuleData('optionalModules')];
                    case 3:
                        _c.sent();
                        if (((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.callback) && this.initialRender) {
                            this.config.get.modules.callback({
                                event: 'newRender',
                                optionalModules: this.readData('optionalModules'),
                                selectableModules: this.readData('selectableModules'),
                                allModules: this.allModules,
                                selectedTerm: this.selectedTerm,
                            });
                            this.initialRender = false;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ContractModules.prototype.findOfferingAndTerm = function (offerings) {
        var termId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.rateBundleTermId);
        for (var _i = 0, offerings_1 = offerings; _i < offerings_1.length; _i++) {
            var offering = offerings_1[_i];
            for (var _a = 0, _b = offering.terms; _a < _b.length; _a++) {
                var term = _b[_a];
                if (String(term.id) === String(termId)) {
                    this.selectedTerm = term;
                    this.selectedOffering = offering;
                    break;
                }
            }
        }
        if (!this.selectedTerm || !this.selectedOffering) {
            console.error('User selected term', termId, 'which was not found from the API');
        }
    };
    ContractModules.prototype.prepareEventListeners = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                //save membership info continue with next section
                this.$container.find('#Membership-Submit').on('click', function () {
                    if ((_this.selectedOffering && _this.selectedTerm) || _this.numberOfModules === 0) {
                        (0, generator_const_1._HideErrorMessage)();
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.rateBundleTermId, _this.selectedTerm.id);
                        _this.redirectToContinue();
                    }
                    else {
                        (0, generator_const_1._ShowErrorMessage)(translation_1.default.t('selectContract'));
                        console.error('No Offering selected');
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    ContractModules.prototype.redirectToContinue = function () {
        var _a, _b, _c;
        if (!((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.noRedirect)) {
            window.location.href = (_c = this.config.get.redirect) !== null && _c !== void 0 ? _c : '/membership/personliche-daten';
        }
    };
    ContractModules.prototype.fillModuleData = function (moduleKey) {
        return __awaiter(this, void 0, void 0, function () {
            var modules, selectedModules, i, _i, modules_1, module_1, moduleIsSelected, refObjectModuleName, refObject, moduleEl, getModules, _loop_1, _a, getModules_1, modulePane, state_1;
            var _this = this;
            var _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                // this function will be called multiple times, clear old entries first
                this.$container.find("[data-module-key=\"".concat(moduleKey, "\"]")).remove();
                if (!this.selectedOffering || !this.selectedTerm)
                    return [2 /*return*/];
                modules = ((_b = this.selectedOffering) === null || _b === void 0 ? void 0 : _b[moduleKey]) || ((_c = this.selectedTerm) === null || _c === void 0 ? void 0 : _c[moduleKey]);
                // filter if name is in settings
                if ((_e = (_d = this.config.get) === null || _d === void 0 ? void 0 : _d.modules) === null || _e === void 0 ? void 0 : _e.hideModulesWithName) {
                    modules = modules.filter(function (a) { return !_this.config.get.modules.hideModulesWithName.includes(a.name); });
                }
                this.numberOfModules += (modules === null || modules === void 0 ? void 0 : modules.length) || 0;
                if (modules === undefined) {
                    return [2 /*return*/];
                }
                this.allModules = __spreadArray(__spreadArray([], this.allModules, true), modules.map(function (a) { return (__assign(__assign({}, a), { type: moduleKey })); }), true);
                selectedModules = JSON.parse(localStorage.getItem(moduleKey) || '[]').map(function (a) { return a.toString(); });
                console.log('Loading', moduleKey, 'modules', modules, 'selected are', selectedModules);
                i = 1;
                for (_i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
                    module_1 = modules_1[_i];
                    moduleIsSelected = selectedModules === null || selectedModules === void 0 ? void 0 : selectedModules.includes(module_1.id.toString());
                    refObjectModuleName = moduleIsSelected
                        ? 'selected' + moduleKey.charAt(0).toUpperCase() + moduleKey.slice(1)
                        : moduleKey;
                    console.log('current module', module_1.id, 'is selected?', moduleIsSelected, 'resulting in key', refObjectModuleName);
                    refObject = this.module.references[refObjectModuleName];
                    if (!((_f = refObject.domElement) === null || _f === void 0 ? void 0 : _f.length)) {
                        console.warn("No data-ref='" + refObjectModuleName + "' found");
                        continue;
                    }
                    moduleEl = refObject.cloneDomElement([
                        { key: 'data-module-count', value: String(i) },
                        { key: 'data-module-key', value: moduleKey },
                        { key: 'data-contract-module', value: String(module_1.id) },
                        { key: 'data-contract-module-name', value: String(module_1.name) },
                        {
                            key: 'data-clickable',
                            value: String(moduleKey === 'selectableModules' || moduleKey === 'optionalModules'),
                        },
                    ], true);
                    refObject.parent.append(moduleEl);
                    moduleEl.find('[data-get="count"]').html(String(i));
                    i++;
                }
                getModules = this.$container.find("[data-module-key=\"".concat(moduleKey, "\"]")).get();
                _loop_1 = function (modulePane) {
                    var addModuleButton = (0, cash_dom_1.default)(modulePane).find('[data-set="add-module-button"]').length
                        ? (0, cash_dom_1.default)(modulePane).find('[data-set="add-module-button"]')[0]
                        : modulePane;
                    if (moduleKey === 'selectableModules' || moduleKey === 'optionalModules') {
                        addModuleButton.style.cursor = 'pointer';
                        addModuleButton.addEventListener('click', function (event) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            var moduleId = modulePane.getAttribute('data-contract-module');
                            var moduleName = modulePane.getAttribute('data-contract-module-name');
                            _this.clickOnSelectableModule(+moduleId, moduleKey, moduleName);
                        });
                    }
                    else {
                        addModuleButton.style.cursor = 'default';
                    }
                    var moduleId = modulePane.getAttribute('data-contract-module');
                    var module_2 = modules.find(function (a) { return String(a.id) === moduleId; });
                    if (!module_2) {
                        console.error('Module not found!', moduleId, modules.map(function (a) { return a.id; }));
                        return { value: void 0 };
                    }
                    var moduleGetters = modulePane.querySelectorAll("[data-get]");
                    moduleGetters.forEach(function (a) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
                        var requested = a.getAttribute('data-get');
                        if (requested === 'imageUrl' && module_2[requested]) {
                            a.style.backgroundImage = "url(" + module_2[requested] + ')';
                            a.style.backgroundSize = 'cover';
                        }
                        else if (requested === 'description') {
                            a.innerHTML = module_2.description.replace(/\n/g, '<br>');
                        }
                        else if ((0, lodash_1.get)(module_2, requested) !== undefined) {
                            var text = (0, lodash_1.get)(module_2, requested);
                            if (requested === 'paymentFrequencyValue') {
                                a.innerHTML = +text === 1 ? translation_1.default.t('per') + ' ' : text;
                            }
                            else {
                                if (requested === 'price') {
                                    var multiplier = (_f = (_c = (_b = (_a = _this.config.get) === null || _a === void 0 ? void 0 : _a.pricePreview) === null || _b === void 0 ? void 0 : _b.paymentFrequencyMultipliers) === null || _c === void 0 ? void 0 : _c[(_e = (_d = _this.selectedTerm) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.toString()]) !== null && _f !== void 0 ? _f : 1;
                                    var newVal = +text * multiplier;
                                    a.innerHTML = translation_1.default.transformCurrency(newVal);
                                }
                                else {
                                    a.innerHTML = translation_1.default.t(text);
                                }
                            }
                        }
                        else if (requested === 'currency') {
                            a.innerHTML = translation_1.default.t(_this.selectedTerm.currencyCode || 'EUR');
                        }
                        else if (requested === 'paymentFrequency') {
                            var value = (_g = module_2.paymentFrequencyValue) !== null && _g !== void 0 ? _g : (_h = _this.selectedTerm) === null || _h === void 0 ? void 0 : _h.paymentFrequencyValue;
                            var unit = (_j = module_2.paymentFrequencyUnit) !== null && _j !== void 0 ? _j : (_k = _this.selectedTerm) === null || _k === void 0 ? void 0 : _k.paymentFrequencyUnit;
                            if (value !== null && unit !== null && value !== undefined && unit !== undefined) {
                                var newVal = (0, time_mapping_const_1.formatValueWithUnit)(value, unit, true);
                                a.innerHTML = translation_1.default.t(newVal);
                            }
                        }
                        else if (_this.config.get.environment === 'dev') {
                            console.info("Your requested data [data-get]=\"".concat(requested, "\" doesn't exist on "), module_2);
                        }
                        //overwrite with settings if set
                        if ((_m = (_l = _this.config.get) === null || _l === void 0 ? void 0 : _l.modules) === null || _m === void 0 ? void 0 : _m.attributeOverwrites) {
                            var overwrites = (_p = (_o = _this.config.get) === null || _o === void 0 ? void 0 : _o.modules) === null || _p === void 0 ? void 0 : _p.attributeOverwrites;
                            if ((_q = overwrites === null || overwrites === void 0 ? void 0 : overwrites[module_2.name]) === null || _q === void 0 ? void 0 : _q[requested]) {
                                a.innerHTML = overwrites[module_2.name][requested];
                            }
                        }
                    });
                };
                for (_a = 0, getModules_1 = getModules; _a < getModules_1.length; _a++) {
                    modulePane = getModules_1[_a];
                    state_1 = _loop_1(modulePane);
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                }
                return [2 /*return*/];
            });
        });
    };
    ContractModules.prototype.clickOnSelectableModule = function (moduleId, moduleKey, moduleName) {
        var _a, _b, _c, _d, _e, _f;
        var moduleIndex = this.readData(moduleKey).findIndex(function (a) { return a === moduleId; });
        console.log('Clicked on module', moduleIndex, 'with key', moduleKey);
        var moduleChangeEvent = {
            moduleClicked: { id: moduleId, category: moduleKey },
        };
        if (moduleIndex >= 0) {
            this.removeElementByIndex(moduleKey, moduleIndex);
            (0, generator_const_1._HideErrorMessage)();
            moduleChangeEvent.action = 'removedFromLocalStorage';
        }
        else if (moduleKey === 'selectableModules') {
            //Different strategies to keep number of modules below the maximum
            if (this.readData(moduleKey).length < this.selectedOffering.maximumNumberOfSelectableModules) {
                this.addModuleId(moduleKey, moduleId, moduleName);
            }
            else if ((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.errorMessageToManyModules) {
                (0, generator_const_1._ShowErrorMessage)("Only ".concat(this.selectedOffering.maximumNumberOfSelectableModules, " modules are allowed per contract"));
            }
            else if ((_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.overwriteToManySelections) {
                //Simply remove last element and use the new one
                this.removeElementByIndex(moduleKey, this.readData(moduleKey).length - 1);
                this.addModuleId(moduleKey, moduleId, moduleName);
            }
            moduleChangeEvent.action = 'addedToLocalStorage';
        }
        else if (moduleKey === 'optionalModules') {
            this.addModuleId(moduleKey, moduleId, moduleName);
            moduleChangeEvent.action = 'addedToLocalStorage';
        }
        if ((_f = (_e = this.config.get) === null || _e === void 0 ? void 0 : _e.modules) === null || _f === void 0 ? void 0 : _f.callback) {
            this.config.get.modules.callback({
                event: moduleChangeEvent,
                optionalModules: this.readData('optionalModules'),
                selectableModules: this.readData('selectableModules'),
                allModules: this.allModules,
                selectedTerm: this.selectedTerm,
            });
        }
        this.communicationService.sendEvent({
            event: 'custom',
            module: this,
            name: 'addonChanged',
            value: true,
        });
        this.renderModule();
    };
    ContractModules.prototype.readData = function (moduleKey) {
        try {
            var data = localStorage.getItem(moduleKey);
            return data ? JSON.parse(data) : [];
        }
        catch (error) {
            console.error('Failed to parse data from localStorage:', error);
            return []; // Return an empty array if there's an error
        }
    };
    // Modify data by adding a new moduleId
    ContractModules.prototype.addModuleId = function (moduleKey, moduleId, moduleName) {
        var data = this.readData(moduleKey);
        data.push(moduleId); // Modify the array
        this.writeData(moduleKey, data); // Write back the modified array to localStorage
        // also save the module names
        var nameKey = (moduleKey + '-names');
        var data2 = this.readData(nameKey);
        data2.push(moduleName);
        this.writeData(nameKey, data2);
    };
    // Write data to localStorage
    ContractModules.prototype.writeData = function (moduleKey, data) {
        try {
            localStorage.setItem(moduleKey, JSON.stringify(data));
        }
        catch (error) {
            console.error('Failed to write data to localStorage:', error);
        }
    };
    // Remove element by index from the data array and update localStorage
    ContractModules.prototype.removeElementByIndex = function (moduleKey, index) {
        var data = this.readData(moduleKey);
        var dataNames = this.readData((moduleKey + '-names'));
        if (index >= 0 && index < data.length) {
            data.splice(index, 1); // Remove the element at the specified index
            this.writeData(moduleKey, data); // Write back the modified array to localStorage
            dataNames.splice(index, 1);
            this.writeData((moduleKey + '-names'), dataNames);
        }
        else {
            console.error('Index out of bounds');
        }
    };
    ContractModules.prototype.preselectModules = function () {
        var _a, _b, _c, _d, _e, _f;
        //Preselect modules by name
        if (((_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.modules) === null || _b === void 0 ? void 0 : _b.preselectModulesWithName) && Array.isArray((_d = (_c = this.config.get) === null || _c === void 0 ? void 0 : _c.modules) === null || _d === void 0 ? void 0 : _d.preselectModulesWithName)) {
            var _loop_2 = function (key) {
                var modules = ((_e = this_1.selectedOffering) === null || _e === void 0 ? void 0 : _e[key]) || ((_f = this_1.selectedTerm) === null || _f === void 0 ? void 0 : _f[key]);
                if (modules === null || modules === void 0 ? void 0 : modules.length) {
                    var preselection_1 = this_1.config.get.modules.preselectModulesWithName;
                    var _loop_3 = function (i) {
                        var moduleId = modules.find(function (a) { return a.name === preselection_1[i]; });
                        var moduleKey = key;
                        if (moduleId && !this_1.readData(moduleKey).some(function (a) { return a === +moduleId.id; })) {
                            this_1.addModuleId(moduleKey, +moduleId.id, moduleId.name);
                            preselection_1.splice(i, 1);
                        }
                    };
                    for (var i = preselection_1.length - 1; i >= 0; i--) {
                        _loop_3(i);
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, _g = ['modules', 'selectableModules', 'optionalModules']; _i < _g.length; _i++) {
                var key = _g[_i];
                _loop_2(key);
            }
        }
    };
    /**
     * Checks all optional modules in local storage if the currently selected offering offers them
     * If not removes them
     * TODO: also check modules and selectable modules
     */
    ContractModules.prototype.cleanUnavailableModules = function () {
        var _a, _b;
        if (this.selectedOffering && this.selectedTerm) {
            var keys = ['optionalModules', 'selectableModules', 'modules'];
            for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                var key = keys_1[_i];
                var requiresUpdate = false;
                var localModules = JSON.parse(localStorage.getItem(key) || '[]');
                var localModuleNames = JSON.parse(localStorage.getItem(key + '-names') || '[]');
                var possibleModules = ((_a = this.selectedOffering) === null || _a === void 0 ? void 0 : _a[key]) || ((_b = this.selectedTerm) === null || _b === void 0 ? void 0 : _b[key]) || [];
                for (var i = 0; i < localModules.length; i++) {
                    if (!possibleModules.map(function (a) { return a.id; }).includes(localModules[i])) {
                        console.warn('User selected a ', key, ' thats not available (', localModules[i], ') for this term, removing it');
                        localModules.splice(i, 1);
                        localModuleNames.splice(i, 1);
                        requiresUpdate = true;
                    }
                }
                if (requiresUpdate) {
                    localStorage.setItem(key, JSON.stringify(localModules));
                    localStorage.setItem(key + '-names', JSON.stringify(localModuleNames));
                }
            }
        }
    };
    return ContractModules;
}());
exports.ContractModules = ContractModules;
